import { createAction } from "@reduxjs/toolkit";

export const impersonationLoading = createAction("admin/impersonationLoading");
export const impersonationLoaded = createAction<{ email: string; id: string }>(
  "admin/impersonationLoaded"
);
export const impersonationError = createAction<string>(
  "admin/impersonationError"
);
export const stopImpersonation = createAction("admin/stopImpersonation");
export const setHasHandledImpersonation = createAction(
  "admin/setHasHandledImpersonation"
);
export const setHasHandledStopImpersonation = createAction(
  "admin/setHasHandledStopImpersonation"
);
